var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"row"},_vm._l((_vm.forms),function(form){return _c('div',{key:form.id,staticClass:"col-6 mb-4"},[_c('div',{staticClass:"well",on:{"click":_vm.goToSignoff}},[_c('h1',[_vm._v(_vm._s(form.title))]),_c('p',[_vm._v(_vm._s(form.note))])])])}),0)])
}
var staticRenderFns = []

export { render, staticRenderFns }